import { div } from "lqx-react";

export const PolicyLabel = div({
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '11px',
    lineHeight: '15px',
    color: '#8695A4',
    paddingLeft: '2px',
    paddingTop: '5px',
    marginTop: '3px',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
});
